import fr from 'facet-rest';
import { buildPageLinkByUserType } from 'Views/Page/Content/Templates';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import { pick } from 'Helpers/Affordances';

// Can use any resource with a householdBalanceSheetPage relationship
export function balanceSheetPageURL(resource, householdID, isAgent) {
  // Come up with a URL builder based on if this relationship exists or not - the reason for the builder is that we don't want to try to construct the URL with undefined/null if we're missing relationships, as that would blow up
  const urlBuilder = pick(resource, {
    [fr.relationships.householdBalanceSheetPage.name]() {
      return buildPageLinkByUserType(resource.relationship(fr.relationships.householdBalanceSheetPage.name).link('related'), isAgent, {
        householdId: householdID, // Useful for the advisor side, which uses the householdId query param (outside of the pageSelfLink) in order to figure out which client to show on the left nav
      });
    },
  }, () => undefined);

  // Build the URL and return it
  return urlBuilder();
}

export function useBalanceSheetPageURL() {
  const { householdResource } = useSimpleHousehold();
  const { isAgent } = useUserContext();
  return balanceSheetPageURL(householdResource, householdResource?.id(), isAgent);
}
